import {getMandarkURL} from '@albert-io/environment';

/** The GraphQL endpoint, with the operation named for the request logs. */
export const graphqlQueryUrl = (operationName: string) =>
  `${getMandarkURL()}/graphql/query?operation=${encodeURIComponent(operationName)}`;
